export default "__VITE_ASSET__Bsma1EuZ__"